/**
 * Canonical definition of RunView's sub-routes / tabs — the single source of truth for:
 *  - the tab chips rendered by RunView (`TabMenu`),
 *  - the redirect allow-list RunView uses to recognise a deep-linked sub-route, and
 *  - the nested route table in `routes/SubRoutes.tsx`.
 *
 * SubRoutes still owns each route's `element` (including the lazy/Suspense wrappers),
 * but pairs it with the path/label from here so the three representations can't drift
 * apart. Add or reorder a tab in ONE place — this array.
 */
export interface RunTab {
  path: string;
  label: string;
  /**
   * Shown as a tab chip in RunView's TabMenu. `false` means the route exists but is
   * reached some other way (e.g. Lap Parsing, opened from the ⋮ actions menu).
   */
  chip: boolean;
  /** Only shown when the run has multiple power/speed/wind sensors (`hasAuxSensors`). */
  requiresAuxSensor?: boolean;
}

export const RUN_TABS: RunTab[] = [
  { path: 'overview', label: 'Overview', chip: true },
  { path: 'plotter', label: 'Plotter', chip: true },
  { path: 'aux-sensor', label: 'Aux Sensor', chip: true, requiresAuxSensor: true },
  { path: 'health-check', label: 'Health Check', chip: true },
  { path: '3d-map', label: '3D Map', chip: true },
  { path: 'lap-parsing', label: 'Lap Parsing', chip: false },
];

/**
 * All valid run sub-route paths (visible chips + hidden routes). Used to recognise a
 * deep-linked sub-route so RunView's default-tab redirect doesn't bounce away from it.
 */
export const RUN_SUBROUTE_PATHS: string[] = RUN_TABS.map((tab) => tab.path);
